import { ActivityItem } from "../../AllActivities/types";

export enum ActivityStatus {
  COMPLETED = 'Completed',
  IN_PROGRESS = 'In Progress',
  FAILED = 'Failed',
  TIMED_OUT = 'Timed Out'
}

export interface RecentActivityItem {
  id: string;
  workflowId?: string;
  workflowExecutionId?: string;
  spaceId?: string;
  reportName: string;
  description: string;
  date: string;
  status: ActivityStatus;
  category: string; // RVM, NetPPM, MFR
  actions: {
    // Actions are handled by handleViewReport function, no URL needed
  };
}

export interface ActivityTableProps {
  items?: ActivityItem[];
  loading?: boolean;
  showAllActions?: boolean; // Show Download and Delete buttons
  onDownload?: (item: ActivityItem) => void;
  onDelete?: (item: ActivityItem) => void;
}
